const useStyles = () => {
  return {
    list: {
      listStyle: "disc",
      pl: 4,
      pt: 0,
      pb: 0,
    },
    listItem: {
      display: "list-item",
      p: 0,
    },
  };
};

export default useStyles;
